import { render, staticRenderFns } from "./listCard.vue?vue&type=template&id=56d36cdc&scoped=true&"
import script from "./listCard.vue?vue&type=script&lang=js&"
export * from "./listCard.vue?vue&type=script&lang=js&"
import style0 from "./listCard.vue?vue&type=style&index=0&id=56d36cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d36cdc",
  null
  
)

export default component.exports